<template>
	<div class="mt-2">
		<table class="table table-bordered">
			<thead class="table-light text-center">
				<tr>
					<th scope="col" title="URL" :style="{ width: '90%' }">
						URL
					</th>
					<th scope="col" title="Content of robots metatag">
						Controls
					</th>
				</tr>
			</thead>

			<tbody>
				<tr v-for="error in errors" :key="error">
					<td class="text-truncate">
						<a
							class="link-secondary"
							:href="error"
							:title="error"
							target="_blank"
							rel="noopener noreferrer"
						>
							{{ error }}
						</a>
					</td>
					<td class="text-center">
						<button
							class="btn btn-sm btn-outline-secondary"
							@click="unhideError(error)"
						>
							Unhide
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script lang="ts">
import { hiddenErrorsService } from "@/services/hiddenErrorsService";
import { computed, defineComponent } from "vue";

export default defineComponent({
	setup() {
		const { hiddenErrors, unhideError } = hiddenErrorsService;
		const errors = computed(() => [...hiddenErrors.value].reverse());
		return { errors, unhideError };
	},
});
</script>
